module.exports = __webpack_public_path__ + "static/media/PrimeShip.044dfb0e.png";